import axios from 'axios';

// require('normalize.css/normalize.css')
require('../styles/main.css')
require('./page.css')
// require('./wp-contact-form-7.js')
// require('./wp-contact-form-7.css')

const termsAndConditions = require("../assets/AV_CodeFish_v1_0.pdf");

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded', 'page-contact')

  // select active navigation item.
  const nav = document.getElementById('nav-contact');
  nav.classList.add('current_page_item');

  // Set correct url for Terms & Conditions.
  const termsLink = document.getElementById('terms');
  termsLink.href = termsAndConditions;

  // Contact form.
  const toast = document.getElementById('toast');
  const loader = document.getElementById('loader');
  const errorDiv = document.getElementById('error');

  // contact form handler.
  const form = document.getElementById('contactform');
  form.onsubmit = (event) => {
    console.log(`submit: ${event}`);
    event.preventDefault();

    loader.style.display = 'block';
    errorDiv.style.display = 'none';
    toast.style.display = 'none';

    // console.log(`Subject: ${event.target.elements['your-subject'].value}`)
    let params = {}
    for (let i = 0; i < event.target.elements.length; i++) {
      const p = event.target.elements[i];
      params[p.name] = p.value
    }
    console.log(`Sending params: ${JSON.stringify(params)}`);

    const url = 'https://ymz73ccxnk.execute-api.eu-west-1.amazonaws.com/prod/email/send/json';
    axios.post(url, params)
    .then(function (response) {
      console.log(response);
      toast.innerHTML = 'Uw bericht is verzonden.'
      toast.style.display = 'block'
    })
    .catch(function (error) {
      console.error(`Failed to send contact form: ${error}`);
      errorDiv.innerHTML = 'Fout tijdens versturen van uw bericht. Probeer het later nogmaals of stuur een e-mail.'
      errorDiv.style.display = 'block'
    }).finally(function() {
      loader.style.display = 'none';
    });

  }

})
